import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/:slug",
    element: <Article />,
  },
  {
    path: "/allchinabuy-spreadsheet-guide",
    element: <Navigate to="/article/allchinabuy-spreadsheet-guide" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;